<template>
	<div class="_modal bg-white" data-tour-id="rec-name-form">
		<div
			class="
				_modal__content
				py-8
				md-down:px-4
				px-12
				md:px-12
				flex flex-col
				items-center
				justify-center
			"
		>
			<div>
				<svg
					width="61"
					height="61"
					viewBox="0 0 61 61"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M30.3034 3.88292C15.7228 3.88292 3.86674 15.8238 3.86674 30.501C3.86674 45.1762 15.7228 57.1171 30.3034 57.1171C44.8839 57.1171 56.7452 45.1762 56.7452 30.501C56.7452 15.8238 44.8839 3.88292 30.3034 3.88292ZM30.3034 60.5C13.8737 60.5 0.5 47.0418 0.5 30.501C0.5 13.9582 13.8737 0.5 30.3034 0.5C46.7382 0.5 60.1068 13.9582 60.1068 30.501C60.1068 47.0418 46.7382 60.5 30.3034 60.5Z"
						fill="#2AA797"
					/>
					<path
						d="M53.0556 30.5009C53.0556 43.1492 42.8702 53.4025 30.3016 53.4025C17.7381 53.4025 7.55273 43.1492 7.55273 30.5009C7.55273 17.8516 17.7381 7.59787 30.3016 7.59787C42.8702 7.59787 53.0556 17.8516 53.0556 30.5009Z"
						fill="#F4C870"
					/>
					<path
						d="M28.1717 40.9L19.9707 31.9556L23.7608 28.4308L27.9092 32.9568L38.2092 20.1L42.2224 23.3604L28.1717 40.9Z"
						fill="white"
					/>
				</svg>
			</div>
			<div
				class="
					_modal__content__title
					text-neutral-700
					font-semibold
					text-2xl
					mt-5
				"
			>
				Đặt tên cho nhóm mục tiêu
			</div>
			<div class="text-center text-neutral-500 mt-2">
				Để thêm vào ngân hàng mục tiêu, vui lòng đặt tên cho nhóm mục
				tiêu vừa tạo
			</div>
			<div class="w-full mt-5">
				<div class="input-group">
					<input
						type="text"
						placeholder="Tên nhóm mục tiêu"
						v-model="name"
					/>
				</div>
			</div>
		</div>
		<div
			class="
				_modal__footer
				px-12
				py-6
				bg-neutral-50
				flex flex-nowrap
				items-center
				md-down:flex-col-reverse
			"
		>
			<button
				type="button"
				class="
					button-p
					text-center
					mr-3
					bg-none
					shadow-none
					text-neutral-500
					hover:text-neutral-700
				"
				@click="$emit('close')"
			>
				Quay lại
			</button>
			<button
				:disabled="!name"
				type="button"
				class="button-p text-center whitespace-nowrap"
				@click="$emit('submit', name)"
			>
				Lưu
			</button>
		</div>
	</div>
</template>
<script setup>
import { ref } from 'vue';

const name = ref('');
</script>
